import { grayColor, whiteColor } from 'assets/jss/material-dashboard-pro-react';

const paymentTypeFormStyle = (theme) => ({
	smallTab: {
		width: '70%',
		margin: '0 auto',
		maxWidth: '624px',
		[theme.breakpoints.down('xs')]: {
			width: '100%',
		},
	},
	tab: {
		marginTop: '24px',
		paddingBottom: '24px',
		backgroundColor: whiteColor,
		borderRadius: '8px 8px 0 0',
	},
	paymentTypeFormTitleWrapper: {
		padding: '16px 24px',
		borderBottom: `1px solid ${grayColor[0]}`,
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	selectTypesContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
		padding: '16px 80px 0 80px',
		gap: '16px',
		[theme.breakpoints.down('md')]: {
			padding: '16px 20px 0 80px',
		},
		[theme.breakpoints.down('xs')]: {
			padding: '16px 30px 0 30px',
		},
	},
	radioButtonsContainer: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		padding: '16px 24px',
	},
	radioButtonsList: { display: 'flex' },
	radioButtons: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		'& label': {
			padding: '0px',
		},
		[theme.breakpoints.down('xs')]: {
			width: '80%',
		},
	},
	input: {
		width: '100%',
		padding: '1px 0',
		'& > span > div > .MuiInputLabel-root': {
			fontSize: 16,
			'&.MuiInputLabel-shrink': {
				fontSize: '14px!important',
			},
		},
		'& > span > div > div > div': {
			fontSize: 16,
		},
		[theme.breakpoints.down('xs')]: {
			width: '80%',
		},
		'& input[type=number]::-webkit-outer-spin-button': {
			'-moz-appearance': 'textfield',
			'-webkit-appearance': 'none',
		},
		'& input[type=number]::-webkit-inner-spin-button': {
			'-moz-appearance': 'textfield',
			'-webkit-appearance': 'none',
		},
	},
	inputLabel: {
		fontSize: theme.fontSize(13),
	},
	inputsFormContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '0px 24px',
		gap: '16px',
	},
	alternativeUnselected: {
		'& > div > div': {
			paddingBottom: '0px',
		},
		'& p': {
			color: 'rgba(0, 0, 0, 0.65) !important',
		},
	},
	alternativeSelected: {
		'& > div > div': {
			paddingBottom: '0px',
			borderBottom: '1px solid rgba(0, 0, 0, 0.65)',
		},
		'& p': {
			color: 'rgba(0, 0, 0, 1) !important',
		},
	},
	bankSelected: {
		color: 'rgba(0, 0, 0, 1) !important',
	},
});

export default paymentTypeFormStyle;
